import { PlusIcon, Trash2Icon } from "lucide-react";
import { useCallback } from "react";
import { useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { AddressControl, InputControl } from "@/components/controls";
import { Button, Divider } from "@/ui-kit";
import { AddressUtils } from "@/utils/address";
import "./index.css";

export const ServiceAreasForm = () => {
  const { t } = useTranslation();

  const { fields, append, remove } = useFieldArray({
    name: "serviceAreas",
  });

  const handleAddServiceArea = useCallback(() => {
    append({
      name: "",
      address: AddressUtils.getEmpty(),
    });
  }, [append]);

  const handleRemoveServiceArea = useCallback(
    (index: number) => {
      return () => {
        remove(index);
      };
    },
    [remove],
  );

  return (
    <>
      {fields.map((field, index) => (
        <div key={field.id} className="service-areas-form__area-section">
          <AddressControl name={`serviceAreas.${index}.address`} />
          <InputControl
            label={t("label.name")}
            name={`serviceAreas.${index}.name`}
          />
          {fields.length > 1 && (
            <div className="service-areas-form__area-footer">
              <Button
                size="sm"
                color="neutral"
                variant="soft"
                startIcon={<Trash2Icon />}
                content={t("action.delete")}
                onClick={handleRemoveServiceArea(index)}
              />
            </div>
          )}
        </div>
      ))}
      <Divider className="service-areas-form__area-divider" />
      <div>
        <Button
          className="service-areas-form__add-area"
          variant="ghost"
          color="neutral"
          startIcon={<PlusIcon />}
          content={t("action.addServiceArea")}
          onClick={handleAddServiceArea}
        />
      </div>
    </>
  );
};
